import React from "react";
import { Box, Button } from "@mui/material";
import ColumnMapper from "./ColumnMapper";

interface StepMappingProps {
  columns: any[]; // Replace 'any' with the appropriate type if known
  data: any; // Replace 'any' with the appropriate type if known
  mapping: any; // Replace 'any' with the appropriate type if known
  updateMapping: (fileCol: string, modelField: string) => void; // Replace 'any' with the appropriate type if known
  modelFields: any; // Replace 'any' with the appropriate type if known
  validateFile: () => void;
  uploading: boolean;
}

export const StepMapping: React.FC<StepMappingProps> = ({ columns, data, mapping, updateMapping, modelFields, validateFile, uploading }) => (
  <Box>
    <ColumnMapper
      columns={columns}
      data={data}
      mapping={mapping}
      onMappingChange={updateMapping}
      modelFields={modelFields}
    />
  </Box>
);
